<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="5" class="pa-0">
          <v-card class="pa-3">
            <div class="d-flex flex-wrap">
              <v-sheet class="pa-7 mt-n7 primary text-center box-shadow" dark width="100%">Verify email</v-sheet>
            </div>

            <v-card-text class="text-center">
              <v-form @submit="confirmEmail">
                <v-text-field label="Email*"
                              v-model="email"
                              color="primary"
                              :error-messages="api_errors['email']"
                />

                <v-text-field
                    v-model="code"
                    color="primary"
                    label="Confirmation code from email*"
                    :error-messages="api_errors['code']"
                />

                <v-btn color="primary" @click="resendCode">Resend code</v-btn>
                <v-btn color="success" type="submit">Submit</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {mapMutations} from "vuex";
export default {
  data:() => ({
    email: '',
    code: '',
    api_errors: [],
  }),
  mounted () {
    this.email = sessionStorage.getItem('email')
  },
  methods: {
    ...mapMutations({
      setAuthUser: 'SET_AUTH_USER',
      setAuthToken: 'SET_AUTH_TOKEN',
    }),
    resendCode() {
      this.axios.post('api/email/resend', {email: this.email})
          // eslint-disable-next-line no-unused-vars
          .then(response => {this.$notify('We have emailed your confirmation code')})
    },
    confirmEmail(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/email/verify', { email: this.email, code: this.code})
          .then(({data}) => {
            this.setAuthToken(data.data.access_token)
            // this.setAuthUser(data.data.user)
            this.$router.push('/')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    }
  }
}
</script>